module.exports = __webpack_public_path__ + "static/d02-82651687c79fc09ff759c85266f64cb7.png";